module.exports = __webpack_public_path__ + "img/1.74160cc2.png";